import useColors from "../customHooks/useColors";

const BaseRequiredMark = () => {
  const [currentColors] = useColors();

  return (
    <span
      style={{
        fontSize: "16px",
        color: currentColors.octonary,
        marginLeft: "3px",
      }}
    >
      *
    </span>
  );
};

export default BaseRequiredMark;
